import { Size } from '@ps/web-core-enums';
import { useScreenSize } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import { MINIMUM_PASS_COUNT, PASS_IMAGES } from '../../constants';
import type { Pass, PassTypeKey } from '../../types/';
import Card from '../Card/Card';
import ComingSoon from '../Card/ComingSoon';
import PassCard from '../Card/PassCard';
import Row from '../Row/Row';

interface PassListProps {
  type: PassTypeKey;
  passData: Pass[];
}

const PassList: React.FC<PassListProps> = ({ type, passData }) => {
  const { greaterThan } = useScreenSize();
  const isMobile = useSelector(select.device.isMobile);
  const smallScreen = !greaterThan(Size.XSmall);
  const isSmallScreen = isMobile || smallScreen;
  const comingSoonCardCount = MINIMUM_PASS_COUNT - passData.length;
  const comingSoonArray = Array.from({ length: comingSoonCardCount });
  const PassImage = PASS_IMAGES[type];

  return (
    <Row passType={type} dataTestId={`row-container-${type}`}>
      {!isSmallScreen && <PassCard image={PassImage} className={type} />}
      {passData.map((cardData, index) => (
        <Card {...cardData} key={index} />
      ))}
      {comingSoonArray.map((_, index) => (
        <ComingSoon type={type} key={index} />
      ))}
    </Row>
  );
};

export default PassList;
